import { render, staticRenderFns } from "./addmembers.vue?vue&type=template&id=45580f0e&scoped=true&"
import script from "./addmembers.vue?vue&type=script&lang=js&"
export * from "./addmembers.vue?vue&type=script&lang=js&"
import style0 from "./addmembers.vue?vue&type=style&index=0&id=45580f0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45580f0e",
  null
  
)

export default component.exports